import type { MouseEvent, ReactNode } from 'react';
import { Card } from '@mui/material';
import type { CardProps } from '@mui/material/Card';
import CardMenuButton, { cardWithMenuSx } from './CardMenuButton';

export interface ActionCardProps extends CardProps {
  onMenuClick?: (event: MouseEvent<HTMLElement>) => void;
  children: ReactNode;
}

const ActionCard = ({
  onMenuClick,
  children,
  sx,
  ...cardProps
}: ActionCardProps) => (
  <Card
    sx={[cardWithMenuSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    {...cardProps}
  >
    {onMenuClick ? <CardMenuButton onClick={onMenuClick} /> : null}
    {children}
  </Card>
);

export default ActionCard;
